export enum Emit {
  ADDED = "added",
  UPDATED = "updated",
  DELETED = "deleted",
}
